'use strict';

function Controller(loans, constants, sponsoredFinanceAdService, alsService, viewport, $location, $anchorScroll) {
    const ctrl = this;
    const adSlotId = constants.adSlotId.shop;
    const calcFieldsCurrency = ['cost', 'down', 'tradein'];
    const calcFieldsRates = ['rate', 'tax'];
    const maxRateLength = 5;
    const maxCurrencyLength = 9;

    ctrl.errors = {};
    ctrl.form = {
        months: '60',
        rate: 0,
        cost: 0,
        down: 0,
        tradein: 0,
        tax: 0,
    };
    ctrl.calculate = calculate;
    ctrl.isTerm = isTerm;
    ctrl.selectTerm = selectTerm;
    ctrl.showMoreDetails = false;
    ctrl.setup = setupCalculator;
    ctrl.updateFields = updateFields;
    ctrl.setFocus = setFocus;
    ctrl.removeFormatting = removeFormatting;
    ctrl.isMobile = viewport.isMobile() || viewport.isTablet();

    function setupCalculator(listingData) {
        try {
            listingData = JSON.parse(listingData);
        } catch (e) {
            listingData = {};
        }

        let stockType = listingData.stockTypeCode ? listingData.stockTypeCode.toLowerCase() : "";

        ctrl.slotNames = setAdSlotNames(stockType);

        ctrl.form.cost = listingData.price ? listingData.price : 0;
        ctrl.form.display = {
            cost: listingData.price ? listingData.price : 0,
            down: 0,
            tradein: 0,
        };
        ctrl.listingData = listingData;
        sponsoredFinanceAdService.getLoanRatePerMonths('60')
            .then(rates => {
                if (rates && rates.data && rates.data.length == 1) {
                    ctrl.rates = rates.data[0];
                    ctrl.form.rate = rates.data[0][stockType] || rates.data[0].used || 0;
                    ctrl.form.months = rates.data[0].term.replace(/\D/g, '');
                    ctrl.estimatedPaymenRate = `${ctrl.form.months} months at ${ctrl.form.rate}% APR`;
                }
                populateFormFromService();
                calculate();
            })
            .catch(e => calculate());
    }

    function setAdSlotNames(stockType) {
        return {
            twinleft: adSlotId + '/buy.' + stockType + '/vdp.finance/twin.left',
            twinright: adSlotId + '/buy.' + stockType + '/vdp.finance/twin.right',
            twinbed: adSlotId + '/buy.' + stockType + '/vdp.finance/lower.textlink'
        };
    }

    function alsTracking(listing) {
        const alsObj = {
            "listingId": listing.listingId ? listing.listingId : "",
            "modelYearId": listing.modelYearId ? listing.modelYearId : "",
            "makeId": listing.makeId ? listing.makeId : "",
            "modelId": listing.modelId ? listing.modelId : "",
            "trimId": listing.trimId ? listing.trimId : "",
            "pageToId": 2250,
            "pageFromId": 2104,
            "stockTypeCode": listing.stockTypeCode ? listing.stockTypeCode : "",
            "sellerId": listing.sellerId ? listing.sellerId : ""
        };
        alsService.clickthru(alsObj);
    }

    function calculate(scroll, fireTracking) {
        if (fireTracking) {
            alsTracking(ctrl.listingData);
        }

        ctrl.form = syncDataToDisplay(ctrl.form);
        loans.calculatePayment(ctrl.form)
            .then(data => {
                ctrl.errors = {};
                ctrl.payment = `$${data.monthly}`;
                ctrl.estimatedPaymenRate = `${ctrl.form.months} months at ${ctrl.form.rate}% APR`;
            })
            .catch(e => {
                handleCalculationError(e);
            });

        if ( ctrl.isMobile && scroll) {
            $location.hash('calculator-top');
            $anchorScroll();
        }
    }

    function updateFields() {

        ctrl.form = syncDataToDisplay(ctrl.form);
        resetFocus();
        loans.validateInput(ctrl.form)
        .then(() => {
            ctrl.errors = {};
        })
        .catch(error => {
            handleCalculationError(error);
        });
    }

    function resetFocus() {
        ctrl.hasFocus = false;
        ctrl.focusdown = false;
        ctrl.focustradein = false;
        ctrl.focuscost = false;
        ctrl.focusrate = false;
        ctrl.focustax = false;
    }

    function setFocus(inputName) {
        ctrl.hasFocus = true;
        ctrl['focus' + inputName] = true;
    }

    function removeFormatting(event) {
        let inputName = event.target.name;
        let textSelected = event.target.selectionStart == event.target.selectionEnd;
        let inputLength = ctrl.form.display[inputName].length;
        let caretAtEnd = event.target.selectionStart == inputLength && event.target.selectionEnd == inputLength;
        let removeFormatting = textSelected && caretAtEnd;

        if (calcFieldsCurrency.includes(inputName) && removeFormatting) {
            ctrl.form.display[inputName] = ctrl.form.display[inputName].replace(/[\,]/g, '');
            if (ctrl.form.display[inputName].length > maxCurrencyLength) {
                ctrl.form.display[inputName] = ctrl.form.display[inputName].slice(0, maxCurrencyLength);
            }
        } else if (calcFieldsRates.includes(inputName) && removeFormatting) {
            if (ctrl.form.display[inputName].length > maxRateLength) {
                ctrl.form.display[inputName] = ctrl.form.display[inputName].slice(0, maxRateLength);
            }
        }

    }

    function syncDataToDisplay(form) {
        let inputLetters;

        calcFieldsCurrency.forEach((attr) => {
            if (form.display && form.display[attr]) {
                inputLetters = String(form.display[attr]).replace(/[0-9\,\.]/g, '');
                if (inputLetters.length === 0){
                    let parsedValue;
                    if (form.display[attr].length > maxCurrencyLength) {
                        parsedValue = parseFloat(form.display[attr].slice(0, maxCurrencyLength), 10);
                    } else {
                        parsedValue = parseFloat(String(form.display[attr]).replace(/[\,]/g, ''), 10);
                    }
                    form[attr] = parsedValue ? parsedValue : 0;
                    form.display[attr] = form[attr].toLocaleString('en-US');
                } else {
                    form[attr] = form.display[attr];
                }
            } else {
                if (attr === 'cost') {
                    form[attr] = form.display[attr];
                    form.display[attr] = '';
                } else {
                    form[attr] = 0;
                    form.display[attr] = form[attr].toLocaleString('en-US');
                }
            }
        });

        calcFieldsRates.forEach((attr) => {
            if (form.display && form.display[attr]) {
                ctrl.form.display[attr] = String(ctrl.form.display[attr]).replace(/[\,]/g, '.');
                inputLetters = form.display[attr].replace(/[0-9\.]/g, '');
                if (inputLetters.length === 0){
                    let parsedValue ;
                    if (form.display[attr].length > maxRateLength) {
                        parsedValue = parseFloat(form.display[attr].slice(0, maxRateLength), 10);
                    } else {
                        parsedValue = parseFloat(form.display[attr], 10);
                    }
                    form[attr] = parsedValue ? parsedValue : 0;
                    form.display[attr] = `${form[attr]}`;
                } else {
                    form[attr] = form.display[attr];
                }
            } else if (form[attr]) {
                inputLetters = String(form[attr]).replace(/[0-9\.]/g, '');
                if (form.display && form.display[attr] === '') {
                    form[attr] = 0;
                    form.display[attr] = `${form[attr]}`;
                } else if (inputLetters.length === 0) {
                    form.display[attr] = `${form[attr]}`;
                }
            } else {
                form[attr] = 0;
                form.display[attr] = `${form[attr]}`;
            }
        });

        return form;
    }

    function handleCalculationError(e) {
        switch (e.code) {
            case 'ti':
                ctrl.errors = {
                    tradein: loans.errorMessages.ti
                };
                break;
            case 'tr':
                ctrl.errors = {
                    intrate: loans.errorMessages.tr
                };
                break;
            case 'st':
                ctrl.errors = {
                    salestax: loans.errorMessages.st
                };
                break;
            case 'vp':
                ctrl.errors = {
                    price: loans.errorMessages.vp
                };
                break;
            case 'dp':
                ctrl.errors = {
                    down: loans.errorMessages.dp
                };
                break;
            case 'dpti':
                ctrl.errors = {
                    down: loans.errorMessages.dpti
                };
                break;
            case 'dpInvalid':
                ctrl.errors = {
                    down: loans.errorMessages.dpInvalid
                };
                break;
            case 'irInvalid':
                ctrl.errors = {
                    intrate: loans.errorMessages.irInvalid
                };
                break;
            case 'stInvalid':
                ctrl.errors = {
                    salestax: loans.errorMessages.stInvalid
                };
                break;
            case 'tiInvalid':
                ctrl.errors = {
                    tradein: loans.errorMessages.tiInvalid
                };
                break;
            case 'vpInvalid':
                ctrl.errors = {
                    price: loans.errorMessages.vpInvalid
                };
                break;
            default:
                ctrl.errors = {
                    down: loans.errorMessages[e.code]
                };
        }
    }

    function populateFormFromService() {
        ['rate', 'cost', 'down', 'tradein', 'tax'].forEach((attr) => {
            ctrl.form[attr] = loans.get(attr) || ctrl.form[attr];
        });
    }

    function selectTerm(term) {
        ctrl.form.months = term;
    }

    function isTerm(term) {
        return ctrl.form.months == term ? 'selected' : '';
    }

}

Controller.$inject = ['loanPaymentService', 'vdpConstants', 'sponsoredFinanceAdService', 'alsService', 'viewport', '$location', '$anchorScroll'];

export default Controller;
